<template>
  <div class="cloud-intercom-page">
    <div class="ci-body ci-body--center">
      <div class="ci-status-icon">
        <img src="@/assets/img/intercom/warning@3x.webp" />
      </div>
      <h2 class="ci-body__heading">
        {{ $t('Intercom.CloudIntercom.TimeoutPage.Heading') }}
      </h2>
      <p class="ci-body__message">
        {{ $t('Intercom.CloudIntercom.TimeoutPage.Message') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeoutPage'
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-body {
  padding-top: 56px;
}
</style>
